<template>
  <Layout :footer-style="2">
    <div class="CallUs">
      <div class="CallUs_content">
        <StaticBanner :banner-date="bannerDate"></StaticBanner>
        <dropdownMenu :pkname="'联系我们'" :pktype="'callus'"></dropdownMenu>
        <div class="titles" v-if="windowWidth>767">
          <div class="in_titles">
            <div class="in_titles_left">
              <img class="in_titles_left_img" src="../../assets/images/industry/tb.png" alt="" />
              <div><span style="margin-right: 10px">&gt;</span><span style="font-size: 18px">联系我们</span></div>
            </div>
            <div class="in_titles_right">
              <a class="changes" @click="goRouter">最新资讯</a>
            </div>
          </div>
        </div>
        <!-- <div class="CallUs-img">
            <img src="../../assets/images/aboutUs/callUs/map.png" alt="">
            <img class="left-map" src="../../assets/images/aboutUs/callUs/left-map.png" alt="">
        </div> -->
        <div class="content_body">
            <div class="map">
                <div class="map-text container ">
                    <div class="fs-1 w-700 title rn-section-gap">博信诚（北京）网络科技有限公司</div>
                    <div class="cont fs-3">北京总部：北京市东城区银河SOHO商厦B座20903<br/>
                        研发基地：北京市朝阳区浙江大厦11层<br/>
                        业务咨询热线：010-84466910<br/>
                        企业邮箱：Company@bossint.com.cn
                    </div>
                    <img src="../../assets/images/home/qrcode.png" alt="">
                </div>
            </div>
            <div class="bottom">
                <div class="bottom-cont container ">
                    <div class="text rn-section-gap">
                        <div class="fs-1 w-700">与我们进行沟通</div>
                        <div class="fs-3">我们会对您的信息进行加密处理，以确保您的信息隐私安全，请放心填写。</div>
                    </div>
                    <div class="bottom-input">
                        <div class="input-one">
                            <input class="input" type="text" v-model="name" placeholder='姓名'>
                            <input type="text" class="input" v-model="phone" placeholder='电话'>
                            <select class="form-select select" v-model="interest" aria-label="请选择感兴趣的类型">
                                <option style="display: none;" selected>请选择业务类型</option>
                                <option value="1">ESCloud</option>
                                <option value="2">EECloud</option>
                                <option value="3">智能RPA</option>
                              </select>
                        </div>
                        <input class="input-big" type="text" v-model="message" placeholder='留言'>
                    </div>
                    <div class="text-center rn-section-gap">
                        <button type="button" class="btn text-primary CallUs-btn color-white fs-3" @click="submit()">提交</button>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style lang="scss">
.CallUs {
  .CallUs_content {
    margin: 0 auto;
    max-width: 1920px;
    margin-top: 80px;
    background: #FFF;
    
    .titles {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      color: #12294f;
      .in_titles {
        display: flex;
        max-width: 1440px;
        height: 70px;
        width: 100%;
        padding: 0 70px;
        align-items: center;

        .in_titles_left {
          display: flex;
          width: 50%;
          align-items: center;
          margin-left: 5%;
          .in_titles_left_img {
            height: 30%;
            margin-right: 10px;
          }
        }
        .in_titles_right {
          display: flex;
          flex: 1;
          justify-content: space-around;
          a {
            color: #12294f;
            padding: 20px 0;
            cursor: pointer;
          }
          .changes {
            color: #186bb3;
            border-bottom: 4px solid #186bb3;
          }
        }
      }
    }
    .content_body {
        .map{
            background: url('../../assets/images/aboutUs/callUs/map.png') center;
           // width: 1920px;
            height:800px;
            .map-text{
                height:800px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                .title{
                    
                }
                img{
                    width: 120px;
                    height: 120px;
                }
            }
        }
      .bottom{
        background: url('../../assets/images/aboutUs/callUs/bottom-bg.png');
        position: relative;
        z-index: 20;
        padding-bottom: 5rem;
        .bottom-cont{
            .bottom-input{
                .input-one{
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 3rem;
                    
                    .input{
                        width: 420px;
                        border-radius: 0;
                        height: 60px;
                        border: 1px solid #e3e3e3;
                    }
                    .select{
                        width: 420px;
                        height: 60px;
                        border-radius: 0;
                        border: 1px solid #e3e3e3;
                        background-size: 30px 15px;
                        color: #65676b;
                        font-size: 16px;
                    }
                }
                .input-big{
                    height: 180px;
                    border-radius: 0;
                    border: 1px solid #e3e3e3;
                }
            }
            .CallUs-btn{
                width: 120px;
                height: 50px;
                background: #186bb3;
            }
        }
      }
    }
  }
}
</style>
<script>
import Layout from "../../components/common/Layout"
import { messageControl } from '@/views/messageDialog/messageDialog.js'
import StaticBanner from "@/components/common/staticBanner/index.vue"
import dropdownMenu from "@/components/common/dropdownMenu.vue"
export default {
  name: "CallUs",
  components: { StaticBanner, Layout,dropdownMenu },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth,
      bannerDate: {
        url: require("@/assets/images/aboutUs/07-06.png"),
        title: "联系我们",
        content: "关注博信诚，了解行业趋势及公司最新动向",
        btn: false,
      },
      interest: '',
      phone: '',
      name: "",
      message: "",
    }
  },
  mounted() {
    // 初始化绑定
    this.messageComponent = new messageControl()
  },
  methods: {
    goRouter(){
      this.$router.push({
        path:"/information"
      })
    },
    submit(){
      if(!this.phone){
        this.messageComponent.message({ type: 'error', content: '请输入手机号', })
        return false
      }
      this.name = ''
      this.phone = ''
      this.interest = ''
      this.message = ''
      this.messageComponent.message({ type: 'success', content: '提交成功' })
    }
  },
}
</script>
